// src/services/exportService.js - NEW FILE

// Export data to CSV format
export const exportToCSV = (data, filename = 'weather_data.csv') => {
  if (!data || data.length === 0) {
    alert('No data to export!');
    return;
  }

  try {
    // Get all unique keys from the data
    const headers = Object.keys(data[0]);
    
    // Create CSV header row
    const csvHeader = headers.join(',');
    
    // Create CSV data rows
    const csvRows = data.map(row => {
      return headers.map(header => {
        let cell = row[header];
        
        // Handle null/undefined
        if (cell === null || cell === undefined) {
          return '';
        }
        
        // Convert to string and escape quotes
        cell = String(cell).replace(/"/g, '""');
        
        // Wrap in quotes if contains comma, newline, or quote
        if (cell.includes(',') || cell.includes('\n') || cell.includes('"')) {
          return `"${cell}"`;
        }
        
        return cell;
      }).join(',');
    });
    
    // Combine header and rows
    const csv = [csvHeader, ...csvRows].join('\n');
    
    // Create blob and download
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    downloadBlob(blob, filename);
    
    console.log(`✅ Exported ${data.length} records to CSV`);
    return true;
  } catch (error) {
    console.error('Error exporting to CSV:', error);
    alert('Failed to export CSV: ' + error.message);
    return false;
  }
};

// Export data to JSON format
export const exportToJSON = (data, filename = 'weather_data.json') => {
  if (!data || data.length === 0) {
    alert('No data to export!');
    return;
  }

  try {
    const json = JSON.stringify(data, null, 2);
    const blob = new Blob([json], { type: 'application/json;charset=utf-8;' });
    downloadBlob(blob, filename);
    
    console.log(`✅ Exported ${data.length} records to JSON`);
    return true;
  } catch (error) {
    console.error('Error exporting to JSON:', error);
    alert('Failed to export JSON: ' + error.message);
    return false;
  }
};

// Export data to Excel-friendly CSV (with BOM for proper encoding)
export const exportToExcelCSV = (data, filename = 'weather_data.csv') => {
  if (!data || data.length === 0) {
    alert('No data to export!');
    return;
  }

  try {
    const headers = Object.keys(data[0]);
    const csvHeader = headers.join(',');
    
    const csvRows = data.map(row => {
      return headers.map(header => {
        let cell = row[header];
        if (cell === null || cell === undefined) return '';
        cell = String(cell).replace(/"/g, '""');
        if (cell.includes(',') || cell.includes('\n') || cell.includes('"')) {
          return `"${cell}"`;
        }
        return cell;
      }).join(',');
    });
    
    const csv = [csvHeader, ...csvRows].join('\n');
    
    // Add BOM for Excel compatibility
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8;' });
    downloadBlob(blob, filename);
    
    console.log(`✅ Exported ${data.length} records to Excel CSV`);
    return true;
  } catch (error) {
    console.error('Error exporting to Excel CSV:', error);
    alert('Failed to export Excel CSV: ' + error.message);
    return false;
  }
};

// Helper function to trigger download
const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.display = 'none';
  
  document.body.appendChild(link);
  link.click();
  
  // Cleanup
  setTimeout(() => {
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }, 100);
};

// Generate filename with date range
export const generateFilename = (stationName, fromDate, toDate, extension = 'csv') => {
  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return d.toISOString().split('T')[0]; // YYYY-MM-DD
  };
  
  const station = stationName ? stationName.replace(/[^a-z0-9]/gi, '_') : 'all_stations';
  const from = formatDate(fromDate);
  const to = formatDate(toDate);
  
  if (from && to) {
    return `${station}_${from}_to_${to}.${extension}`;
  } else if (from) {
    return `${station}_from_${from}.${extension}`;
  } else {
    return `${station}_data.${extension}`;
  }
};

const exportService = {
  exportToCSV,
  exportToJSON,
  exportToExcelCSV,
  generateFilename,
};
export default exportService;